'use client';
import { useTranslations } from 'next-intl';
import React from 'react';
import InvoiceUpload from './invoice-upload';
import { ReferenceTariffType } from '../types/reference-tariff-type';
import useOfferComparisonStore from '../store/use-offer-comparison-store';
import { useSearchParams } from 'next/navigation';

export default function InvoiceUploadBanner() {
  const t = useTranslations('invoiceUpload');
  const comparisonMode = useOfferComparisonStore((state) => state.mode);
  const searchParams = useSearchParams();
  const isAutoInvoiceUpload = searchParams.has('invoiceUpload');
  const title =
    comparisonMode === ReferenceTariffType.average
      ? 'upload.title'
      : 'repeatUpload.shortenedBody';

  return (
    <div
      data-testid="invoice-upload-title"
      className="flex flex-col text-center leading-[21px] text-sm p-4"
    >
      {t(title)}
      <div className="underline font-bold underline-offset-4">
        <InvoiceUpload
          data-testid="invoice-upload"
          autoOpen={isAutoInvoiceUpload}
        >
          {t('upload.cta')}
        </InvoiceUpload>
      </div>
    </div>
  );
}
